/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Limited Avail";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="info"><_components.p>{"This feature isn’t available to all Chronosphere Observability Platform users and\nmight not be visible in your app. For information about enabling this feature in your\nenvironment, contact "}<_components.a href="/support">{"Chronosphere Support"}</_components.a>{"."}</_components.p></Alert>;
}

export default MDXLayout